import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { AlertaPainel, JsonReturn, ObjectParam } from '../shared/interface/generic-interface';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class PopupConfigService {

  configPendentes: any = null;
  alertas: Array<AlertaPainel> = [];

  private tempMaxPermitidaSubject = new BehaviorSubject<number>(0);
  tempMaxPermitida$ = this.tempMaxPermitidaSubject.asObservable();

  private tempMaxPermitidaAtivaSubject = new BehaviorSubject<boolean>(false);
  tempMaxPermitidaAtiva$ = this.tempMaxPermitidaAtivaSubject.asObservable();

  setTempMaxPermitida(valor: number) {
    this.tempMaxPermitidaSubject.next(valor);
  }

  setTempMaxPermitidaAtiva(valor: boolean) {
    this.tempMaxPermitidaAtivaSubject.next(valor);
  }

  constructor(private conService: ApiConService) {}

  async getConfiguracoesGerais(){
      try {
          const response: JsonReturn = await this.conService.patch('DCConfiguracaoGeral');
          let configuracoesGerais = response.response
          return configuracoesGerais;
      } catch (error) {
          console.log(error);
      }
  }

  async updateConfiguracaoGeral(id: number, objParam: ObjectParam) {
      try {
        const response = await this.conService.put('DCConfiguracaoGeral', `${id}`, objParam);
        return response.response;
      }catch (error) {
          console.log(error);
      }
    }

  async updateAlerta(id: number, objParam: ObjectParam) {
    try {
      const response = await this.conService.put('DCAlertaPainel', `${id}`, objParam);
      return response[0];
    }catch (error) {
        console.log(error);
    }
  }

  async getAlertas() {
    try {
      const response: JsonReturn = await this.conService.patch('DCAlertaPainel');
      this.alertas = response.response;
      document.getElementById('btnMostraAlertaNotic').click();
      return response.response;
    }catch (error) {
        console.log(error);
    }
  }

  async addConfiguracaoGeral(objParam: ObjectParam){
    try {
      const response: JsonReturn = await this.conService.post('DCConfiguracaoGeral', objParam);
      return response.response;
    }catch (e) {
      console.log(e);
    }
  }

  async getConfiguracaoGeralId(id) {
    try {
      const response: JsonReturn = await this.conService.patch('DCConfiguracaoGeral/'+id);
      return response.response;
    }catch (e) {
      console.log(e);
    }
  }

  atualizaValoresTemperaturMaxima(alerta: AlertaPainel): void {
    this.tempMaxPermitidaAtivaSubject.next(alerta.Ativo ?? false);
    this.tempMaxPermitidaSubject.next(Number(alerta.Valor?.replace('°C','') ?? 0));
  }
}
